<template>
  <div>
    <PageHeader />

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card mb-3">
            <div class="row no-gutters">
              <div class="col-12">
                <div class="card-body">
                  <h1>Default Settings</h1>
                  <hr />
                  <form id="form-proper" v-if="ableToUpdateHeadOffice">
                    <div>
                      <b-form-group
                        id="fieldset-1"
                        label="Head Office"
                        label-for="head-office"
                      >
                        <b-form-select
                          v-if="isNonBXI"
                          v-model="headOffice"
                          class="mb-3"
                        >
                          <b-form-select-option
                            v-for="site in options.sites"
                            :key="site.id"
                            :value="site.id"
                            >{{ site.name }}</b-form-select-option
                          >
                        </b-form-select>
                        <b-form-select v-else v-model="headOffice" class="mb-3">
                          <b-form-select-option
                            v-for="site in options.sites"
                            :key="site.id"
                            :value="site.third_party_site_id"
                            >{{ site.name }}</b-form-select-option
                          >
                        </b-form-select>
                        <div v-if="headOfficeChange">
                          <b-button
                            v-if="!hasHeadOffice"
                            variant="primary"
                            @click="addHeadOffice()"
                            >save</b-button
                          >
                          <b-button
                            v-else
                            variant="primary"
                            @click="updateHeadOffice()"
                            >update</b-button
                          >
                        </div>
                      </b-form-group>
                    </div>
                  </form>
                  <div>
                    <h2 v-if="ableToUpdateHeadOffice">Other Settings</h2>
                    <div class="d-flex flex-row">
                      <div class="p-2">
                        <a-button type="link" @click="openChangePassword">
                          Change Password
                        </a-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-drawer
      :width="changePasswordDrawer.width"
      :placement="changePasswordDrawer.placement"
      :visible="changePasswordDrawer.visible"
      @close="closeDrawer"
    >
      <PasswordUpdateForm @closeDrawer="closeDrawer" />
    </a-drawer>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import PageHeader from '@/components/Page/Header';
import { mapGetters } from 'vuex';
import secureStorage from '../../controllers/secureStorage';
import PasswordUpdateForm from './PasswordUpdateForm.vue';

export default {
  name: 'DefaultSettings',
  components: {
    PageHeader,
    PasswordUpdateForm
  },
  data() {
    return {
      headOffice: null,
      source: secureStorage.getItem('source'),
      changePasswordViewMode: true,
      changePasswordDrawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      options: {
        sites: []
      }
    };
  },

  methods: {
    closeDrawer() {
      this.changePasswordDrawer.visible = false;
    },
    async openChangePassword() {
      this.changePasswordViewMode = true;
      this.changePasswordDrawer.visible = true;
    },

    async getSites() {
      const response = await HTTPRequest.getRequest('/api/v1/sites', {
        per_page: 1000
      });
      this.options.sites = response.data;
    },
    async addHeadOffice() {
      const response = await HTTPRequest.postRequest(
        '/api/v1/account_head_offices/',
        {
          account_head_office: {
            site_id: this.headOffice
          }
        }
      );
      if (response.site_id) {
        this.$notification.success({
          message: 'Head Office has been updated.'
        });

        secureStorage.setItem('headOffice', response.site_id);
        this.$store.dispatch('setHeadOffice', response);
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    },
    async updateHeadOffice() {
      const response = await HTTPRequest.putRequest(
        `/api/v1/account_head_offices/${this.getHeadOfficeId}`,
        {
          account_head_office: {
            site_id: this.headOffice
          }
        }
      );
      if (response.id) {
        this.$notification.success({
          message: 'Head Office has been updated.'
        });

        secureStorage.setItem('headOffice', response.site_id);
        this.$store.dispatch('setHeadOffice', response);
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    }
  },

  created() {
    this.$store.dispatch('setCurrentModule', 'Settings');
  },
  computed: {
    ...mapGetters([
      'getHeadOffice',
      'getHeadOfficeId',
      'getModuleSelectedActions'
    ]),
    isNonBXI() {
      return this.source === 'clp' || false;
    },
    ableToUpdateHeadOffice() {
      return this.getModuleSelectedActions.includes('Update Head Office');
    },
    headOfficeChange() {
      if (this.getHeadOffice == this.headOffice) {
        return false;
      } else {
        return true;
      }
    },
    hasHeadOffice() {
      if (this.getHeadOffice != null) {
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted() {
    await this.getSites();
    if (this.getHeadOffice != null) {
      this.headOffice = this.getHeadOffice;
    }
  },

  watch: {
    '$store.getters.getHeadOffice': function (obj) {
      this.headOffice = obj;
    }
  }
};
</script>

<style scoped></style>
